import React, { useEffect, useMemo, useRef, useState } from 'react';
import clsx from 'clsx';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper/modules';

import { slideOptions } from './_vars';
import { useNewSizeGuideContext } from './context/useNewSizeGuideContext';

import styles from './NewSizeGuide.module.scss';
import { theme } from './_theme';

export const SizeCardsSlider = ({ cards, isPDP }) => {
  const swiperRef = useRef(null);
  const [allSlidesVisible, setAllSlidesVisible] = useState(false);
  const { activeRow, setActiveRow, getNumber } = useNewSizeGuideContext();

  if (!cards?.length) {
    return null;
  }

  useEffect(() => {
    if (swiperRef?.current) {
      setAllSlidesVisible(!swiperRef?.current.allowSlideNext && !swiperRef?.current.allowSlidePrev);
    }
  }, [swiperRef]);

  useEffect(() => {
    if (swiperRef?.current && !!activeRow) {
      const activeIndex = cards.findIndex((card) => activeRow === getNumber(card?.fitsAuSize));
      swiperRef?.current?.slideTo(activeIndex);
    }
  }, [activeRow, swiperRef]);

  const options = useMemo(
    () => ({ ...slideOptions(swiperRef, allSlidesVisible, isPDP) }),
    [swiperRef, allSlidesVisible, isPDP],
  );

  const renderCard = (card) => (
    <div
      className={clsx(styles.sizeCard, { [styles.activeCard]: activeRow === getNumber(card.fitsAuSize) })}
      onClick={() => setActiveRow(getNumber(card.fitsAuSize))}
    >
      <div className={styles.cardTitle}>
        <span className={styles.cardDot} />
        <span>AU {card.fitsAuSize}</span>
      </div>
      <div>
        <ul>
          {card.internationalSizes.map((item, key) => {
            return (
              <li key={`list_${key}`}>
                <span>{item.country}</span>
                <span>{item.sizeValue}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );

  return (
    <div
      className={clsx(styles.sizeCardBlock, {
        [styles.isPdpPage]: isPDP,
        [styles.isSabaStyle]: theme === 'saba' || theme === 'sportscraft',
      })}
    >
      <div className={styles.titleContainer}>
        <h4 className={styles.sizeCardTitle}>international conversion</h4>
      </div>
      <Swiper
        ref={swiperRef}
        modules={[Scrollbar]}
        scrollbar={{
          el: '.guides-swiper-scrollbar',
          draggable: true,
        }}
        {...options}
      >
        {cards?.map((card, index) => {
          return (
            <SwiperSlide key={index} virtualIndex={card.title}>
              {renderCard(card)}
            </SwiperSlide>
          );
        })}
        <div tabIndex="0" className="swiper-scrollbar js-swiper-scrollbar guides-swiper-scrollbar" />
      </Swiper>
    </div>
  );
};
